module.exports = __webpack_public_path__ + "img/BM_Logo_Full_Size.9d36a1d6.svg";